<template>
  <div class="general-active-section">
    <div v-if='validatedEntry === true'>
      <h4 class="text-center">{{ computeCaption(fields_en['confirmation_number'], $store.state.lang.value.toLowerCase()) }}</h4>
      <hr class="hr-green" />
      <barcode :value="this.confirmationNumber" class="text-center" format="CODE128">
        Show this if the rendering fails.
      </barcode>
      <hr class="hr-green" />
      <div class="text-center" style="margin-top:20px">
        <h4>{{computeCaption(fields_en['email'], $store.state.lang.value.toLowerCase()) + ':  ' + email}}</h4>
        <h4>{{computeCaption(fields_en['firstName'], $store.state.lang.value.toLowerCase()) + ':  ' + firstName}} </h4>
        <h4>{{computeCaption(fields_en['lastName'], $store.state.lang.value.toLowerCase()) + ':  ' + lastName}}</h4>
      </div>
    </div>
    <div v-if="validatedEntry === false">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h5 class="text-center">We couldn't find your registration.</h5>
          <h4 class="text-center">Try again!</h4>
        </div>
      </div>
    </div>
    <div v-if="validatedEntry === ''" v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>

import axios from 'axios'
import VueBarcode from 'vue-barcode'
import {TranslationsUtils} from '../../../../utils/Translations'
export default {
  components: {
    'barcode': VueBarcode
  },
  data () {
    return {
      validatedEntry: '',
      confirmationNumber: this.$route.params.confirmation_number || '',
      siteCode: this.$route.params.site_code || '',
      firstName: this.$route.params.first_name || '',
      lastName: this.$route.params.last_name || '',
      email: localStorage.getItem('email'),
      fields_en: {
        confirmation_number: 'Confirmation Number',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Your Email'
      }
    }
  },
  mixins: [TranslationsUtils],
  async beforeMount () {
    this.confirmationNumber = this.$route.params.confirmation_number
    this.siteCode = this.$route.params.site_code
    this.firstName = this.$route.params.first_name
    this.lastName = this.$route.params.last_name
    await this.securityCheck()
  },
  methods: {
    async securityCheck () {
      await axios.get(process.env.SERVER_URI + '/check/valid/confirmation/entry/' + this.siteCode + '/' + this.confirmationNumber + '/' + this.firstName + '/' + this.lastName)
        .then(async (response) => {
          this.validatedEntry = response.data
        })
    }
  }
}
</script>

<style scoped>
.confirmation_number{
  text-align: center;
  font-size: 20px;
}

.hr-green {
  background-color: #1a6701;
  height: 5px;
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/OrderConfirmation.vue